import { clientPublic, clientPublicService } from 'helper/axios';
import { handleError } from 'helper/rest';
import { encodeId } from 'helper/sqids';
let resError = ''

export const getDataCompany = async ({ token, level, level_id }) => {
  try {
    return await clientPublic

      //asc desc
      .get(`company?level=${level}&level_id=${level_id}&orderby=code|asc&limit=999`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getDataCompany_Level_v2 = async ({ token, level, level_id }) => {
  try {
    const response = await clientPublicService.get(`/core/company`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        level,
        level_id,
        orderby: 'code|asc',
        limit: 999,
        status: 'all',
      },
    })
    return {
      status: response.status,
      data: response.data.result,
      error: false,
    }
  } catch (error) {
    const { response } = error || {}
    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }
    return {
      status: response?.status,
      data: null,
      error: true,
    }
  }
}

export const getDataCompanyByID = async ({ token, level_id }) => {
  try {
    return await clientPublic
      .get(`company/${level_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeCompany = async ({ token, language }) => {
  try {
    return await clientPublic
      .get(`company/tree?lang=${language}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const saveCompany = async ({ params, token }) => {
  try {
    return await clientPublicService
      .post(`core/management/company/create`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

// export const deleteCompany = async ({ params, token, idCompany, code }) => {
//   try {
//     return await clientPublic
//       .delete(`company/${idCompany}?code=${code}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },

//         data: params,
//       })
//       .then((response) => {
//         return response
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return error
//   }
// }

export const deleteCompany = async ({ params, token, idCompany, code }) => {
  try {
    return await clientPublicService
      .delete(`core/management/company/${idCompany}?code=${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// export const updateCompany = async ({ params, token, idCompany }) => {
//   try {
//     return await clientPublic
//       .put(`company/${idCompany}`, params, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return resError
//   }
// }

export const updateCompany = async ({ params, token, idCompany }) => {
  try {
    return await clientPublicService
      .put(`core/management/company/${idCompany}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

// new api service-project
export const getDataCompanyV2 = async ({ token, level, level_id, parent_id }) => {
  try {
    let params = {}
    if (level === 2) {
      params = {
        company_id: level_id,
      }
    } else if (level === 3) {
      params = {
        company_id: parent_id,
        operation_id: level_id,
      }
    }

    return await clientPublicService
      .get(`/core/management/company`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getBusinessListV2 = async ({
  token,
  page,
  per_page,
  search_by,
  search,
  order_by,
  order,
}) => {
  try {
    const params = {
      page,
      per_page,
    }

    if (search_by && search) {
      params.search_by = search_by
      params.search = search
    }

    if (order_by && order) {
      params.order_by = order_by
      params.order = order
    }

    return await clientPublicService
      .get(`/core/management/business`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getSyncBusinessDropdown = async ({ token, search = '' }) => {
  try {
    const params = {}
    if (search) {
      params.search = search
    }
    return await clientPublicService
      .get(`/core/management/business/sync-business-dropdown`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeCompanyV2 = async ({ token, language }) => {
  try {
    return await clientPublicService
      .post(
        `/core/management/company/tree`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const createBusiness = async ({ params, token }) => {
  try {
    return await clientPublicService
      .post('/core/management/business', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response)
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const updateBusiness = async ({ params, token, id }) => {
  try {
    const encodedId = encodeId(id)
    return await clientPublicService
      .put(`/core/management/business/${encodedId}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response)
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}
